import React from "react";

function VideoPreview({ url }) {
  const vimeoUrl = `${url}?h=99fc1a7055&color=7f3ff6`;
  const urlpoint = url ? url.includes("vimeo") : false;
  const urlreplacer = url ? url.replace("watch?v=", "embed/") : "";
  const videoUrl = urlpoint ? vimeoUrl : urlreplacer;

  return (
    <div style={{ marginTop: "0.4vw" }}>
      <iframe
        src={url ? videoUrl : ""}
        width="640"
        height="360"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}

export default VideoPreview;
